import { Search211Record, LeafletPlace } from '../../definitions'
import { LatLngTuple } from 'leaflet'
import { calcDistance } from './index'

/**
 * Transform 211 search record into Leaflet Place representation.
 * @param {Search211Record} result
 * @param {number?} lat
 * @param {number?} lng
 * @return {LeafletPlace}
 */
export const transformResultToLeafletPlaces = (result, lat, lng) => {

  const distance =
    (result.Latitude !== 0 || result.Longitude !== 0) && (lat !== 0 || lng !== 0)
      ? new Intl.NumberFormat('en-CA', {
        style: 'unit',
        unit: 'kilometer',
        maximumFractionDigits: 1,
      }).format(calcDistance(lat, lng, result.Latitude, result.Longitude))
      : '-- KM'

  return {
    id: `${result.id}`,
    index: null,
    label: result.PublicName,
    latitude: result.Latitude,
    longitude: result.Longitude,
    distance: distance,
    popupContent: null,
  }
}

/**
 * Extract all places location coordinates for using as map bounds.
 * @param {LeafletPlace[]} places
 * @return {LatLngTuple[]}
 */
export const composePlacesBounds = (places) => {
  if (!places) {
    return []
  }

  return places.map((place) => {
    /**
     * @type {LatLngTuple}
     */
    return [place.latitude, place.longitude]
  })
}
